window.DESIGNS = {
  "cities": [
    {
      "name": "New York",
      "image": "assets/media/canvas/01-new-york.jpg"
    },
    {
      "name": "Las Vegas",
      "image": "assets/media/canvas/02-las-vegas.jpg"
    },
    {
      "name": "Toronto",
      "image": "assets/media/canvas/03-toronto.jpg"
    },
    {
      "name": "Tokyo",
      "image": "assets/media/canvas/04-tokyo.jpg"
    },
    {
      "name": "Tokyo Fujiyama",
      "image": "assets/media/canvas/05-tokyo-fujiyama.jpg"
    },
    {
      "name": "Tokyo Sakura",
      "image": "assets/media/canvas/06-tokyo-sakura.jpg"
    },
    {
      "name": "Paris",
      "image": "assets/media/canvas/07-paris.jpg"
    },
    {
      "name": "Los Angeles",
      "image": "assets/media/canvas/08-los-angeles.jpg"
    },
    {
      "name": "Chicago",
      "image": "assets/media/canvas/09-chicago.jpg"
    },
    {
      "name": "San Francisco",
      "image": "assets/media/canvas/10-san-francisco.jpg"
    },
    {
      "name": "Venice",
      "image": "assets/media/canvas/11-venice.jpg"
    },
    {
      "name": "Seoul",
      "image": "assets/media/canvas/12-seoul.jpg"
    },
    {
      "name": "Florence",
      "image": "assets/media/canvas/13-florence.jpg"
    },
    {
      "name": "Berlin",
      "image": "assets/media/canvas/14-berlin.jpg"
    },
    {
      "name": "Bangkok",
      "image": "assets/media/canvas/15-bangkok.jpg"
    },
    {
      "name": "Singapore",
      "image": "assets/media/canvas/16-singapore.jpg"
    },
    {
      "name": "Budapest",
      "image": "assets/media/canvas/17-budapest.jpg"
    },
    {
      "name": "Hamburg",
      "image": "assets/media/canvas/18-hamburg.jpg"
    },
    {
      "name": "Cologne",
      "image": "assets/media/canvas/19-cologne.jpg"
    },
    {
      "name": "London Big Ben",
      "image": "assets/media/canvas/20-london-big-ben.jpg"
    },
    {
      "name": "London Tower Bridge",
      "image": "assets/media/canvas/21-london-tower-bridge.jpg"
    },
    {
      "name": "Sydney",
      "image": "assets/media/canvas/22-sydney.jpg"
    },
    {
      "name": "India Taj Mahal",
      "image": "assets/media/canvas/23-india-taj-mahal.jpg"
    },
    {
      "name": "Venice Canal",
      "image": "assets/media/canvas/24-venice-canal.jpg"
    },
    {
      "name": "Amsterdam",
      "image": "assets/media/canvas/25-amsterdam.jpg"
    },
    {
      "name": "Cappadocia",
      "image": "assets/media/canvas/26-cappadocia.jpg"
    },
    {
      "name": "Hong Kong",
      "image": "assets/media/canvas/27-hong-kong.jpg"
    },
    {
      "name": "Kuala Lumpur",
      "image": "assets/media/canvas/28-kuala-lumpur.jpg"
    },
    {
      "name": "Dream Castle",
      "image": "assets/media/canvas/29-dream-castle.jpg"
    },
    {
      "name": "Carnival",
      "image": "assets/media/canvas/30-carnival.jpg"
    }
  ],
  "nature": [
    {
      "name": "Hummingbird",
      "image": "assets/media/calmingnature/01-hummingbird.jpg"
    },
    {
      "name": "Northern Lights",
      "image": "assets/media/calmingnature/02-northern-lights.jpg"
    },
    {
      "name": "Rainy Day",
      "image": "assets/media/calmingnature/03-rainy-day.jpg"
    },
    {
      "name": "Bees & Daisies",
      "image": "assets/media/calmingnature/04-bees-daisies.jpg"
    },
    {
      "name": "Lilypad Dreams",
      "image": "assets/media/calmingnature/05-lilypad-dreams.jpg"
    },
    {
      "name": "Yellowstone Cubs",
      "image": "assets/media/calmingnature/06-yellowstone-cubs.jpg"
    },
    {
      "name": "KoalaHugz",
      "image": "assets/media/calmingnature/07-koalahugz.jpg"
    },
    {
      "name": "Swans Lake",
      "image": "assets/media/calmingnature/08-swans-lake.jpg"
    },
    {
      "name": "Climb Me To The Moon",
      "image": "assets/media/calmingnature/09-climb-me-to-the-moon.jpg"
    },
    {
      "name": "Mouse & Dandelion",
      "image": "assets/media/calmingnature/10-mouse-dandelion.jpg"
    },
    {
      "name": "Cat & Butterfly",
      "image": "assets/media/calmingnature/11-cat-butterfly.jpg"
    },
    {
      "name": "Polar Bears [ New ]",
      "image": "assets/media/calmingnature/12-polar-bears-new.jpg"
    },
    {
      "name": "Lovebirds [ New ]",
      "image": "assets/media/calmingnature/13-lovebirds-new.jpg"
    },
    {
      "name": "Hawk [ New ]",
      "image": "assets/media/calmingnature/14-hawk-new.jpg"
    },
    {
      "name": "Horse [ New ]",
      "image": "assets/media/calmingnature/15-horse-new.jpg"
    },
    {
      "name": "Camels [ New]",
      "image": "assets/media/calmingnature/16-camels-new.jpg"
    },
    {
      "name": "Chipmunk [ New ]",
      "image": "assets/media/calmingnature/17-chipmunk-new.jpg"
    },
    {
      "name": "Flamingos [ New ]",
      "image": "assets/media/calmingnature/18-flamingos-new.jpg"
    },
    {
      "name": "Leopard [ New ]",
      "image": "assets/media/calmingnature/19-leopard-new.jpg"
    },
    {
      "name": "Lion Cub [ New ]",
      "image": "assets/media/calmingnature/20-lion-cub-new.jpg"
    },
    {
      "name": "Otters [ New ]",
      "image": "assets/media/calmingnature/21-otters-new.jpg"
    },
    {
      "name": "Seals [ New ]",
      "image": "assets/media/calmingnature/22-seals-new.jpg"
    },
    {
      "name": "Sunflower [ New ]",
      "image": "assets/media/calmingnature/23-sunflower-new.jpg"
    }
  ],
  "wildlife": [
    {
      "name": "The Jungle (Zebra + Lion + Jaguar + Elephant)",
      "image": "assets/media/wildlife/01-the-jungle-zebra-lion-jaguar-elephant.jpg"
    },
    {
      "name": "Under The Sea (Whale + Dolphins + Jellyfish + Turtle)",
      "image": "assets/media/wildlife/02-under-the-sea-whale-dolphins-jellyfish-turtle.jpg"
    },
    {
      "name": "Tropical Forest (Tiger + Wolf + Monkey + Tucan)",
      "image": "assets/media/wildlife/03-tropical-forest-tiger-wolf-monkey-tucan.jpg"
    },
    {
      "name": "Lost Kingdom (Unicorn + Dragon + Fairy + Jixy)",
      "image": "assets/media/wildlife/04-lost-kingdom-unicorn-dragon-fairy-jixy.jpg"
    }
  ],
  "japan": [
    {
      "name": "Great Wave Off Kanagawa - 神奈川沖浪裏",
      "image": "assets/media/talesofjapan2/01-great-wave-off-kanagawa.jpg"
    },
    {
      "name": "Dragon and Thunder - 龍と雷",
      "image": "assets/media/talesofjapan2/02-dragon-and-thunder.jpg"
    },
    {
      "name": "Tiger Rise - 虎の昇り",
      "image": "assets/media/talesofjapan2/03-tiger-rise.jpg"
    },
    {
      "name": "Phoenix Rebirth - 環",
      "image": "assets/media/talesofjapan2/04-phoenix-rebirth.jpg"
    },
    {
      "name": "Koi Dreams - 鯉の夢",
      "image": "assets/media/talesofjapan2/05-koi-dreams.jpg"
    },
    {
      "name": "Celestial Peacock - 天の孔雀",
      "image": "assets/media/talesofjapan2/06-celestial-peacock.jpg"
    },
    {
      "name": "Geisha's True Spirit - 不撓不屈",
      "image": "assets/media/talesofjapan2/07-geisha-s-true-spirit.jpg"
    }
  ]
};
